import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// reducers
import { LogAccessi as LogAccessiReducer } from '../../reducers/r_index';
import { FilterLogAccessi as FilterLogAccessiReducer } from '../../reducers/r_index';

//Components
import GridLogAccessiCmp from '../../components/log/GridLogAccessiCmp';

// Material helpers
import { withStyles } from '@material-ui/core';

// Component styles
const styles = theme => ({
    detailContainer: {
        margin: '10px',
    },
});

class GridLogAccessi extends Component {

    componentDidMount() {
        if (this.props.codiceUtente !== 'anonymous')
            this.props.getLogAccessi(this.props.codiceUtente);
    }

    componentDidUpdate(propsPrecedenti) {
        if (this.props.codiceUtente !== propsPrecedenti.codiceUtente) {
            if (this.props.codiceUtente !== 'anonymous')
                this.props.getLogAccessi(this.props.codiceUtente);
        }
    }

    render() {
        const { ...props } = this.props;

        return (
            <GridLogAccessiCmp {...props} />
        );

    }
}

GridLogAccessi.propTypes = {
    getLogAccessi: PropTypes.func.isRequired,
    log_accessi: PropTypes.arrayOf(PropTypes.object).isRequired,
    getLogAccessiRequestStatus: PropTypes.string.isRequired,

    selection: PropTypes.arrayOf(PropTypes.number).isRequired,
    selectedRowIndex: PropTypes.number.isRequired,
    selected_log_accesso: PropTypes.shape({}).isRequired,
    filters: PropTypes.arrayOf(PropTypes.object).isRequired,
    sorting: PropTypes.arrayOf(PropTypes.object).isRequired,
    currentPage: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    pageSizes: PropTypes.arrayOf(PropTypes.number).isRequired,
    expandedRowIds: PropTypes.arrayOf(PropTypes.number).isRequired,
    columnWidths: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

    onSortingChange: PropTypes.func.isRequired,
    onFiltersChange: PropTypes.func.isRequired,
    onCurrentPageChange: PropTypes.func.isRequired,
    onPageSizeChange: PropTypes.func.isRequired,
    onColumnWidthsChange: PropTypes.func.isRequired,
    handleRowSelection: PropTypes.func.isRequired,

    setSelectedLogAccesso: PropTypes.func.isRequired,

    codiceUtente: PropTypes.string.isRequired,
};


const mapDispatchToProps = dispatch => ({
    getLogAccessi: (codiceUtente) => { dispatch(LogAccessiReducer.creators.getLogAccessiRequest(codiceUtente)); },

    onSortingChange: (sorting) => { dispatch(FilterLogAccessiReducer.creators.onGridAction('sorting', sorting)) },
    onFiltersChange: (filters) => { dispatch(FilterLogAccessiReducer.creators.onGridAction('filters', filters)) },
    onCurrentPageChange: (currentPage) => { dispatch(FilterLogAccessiReducer.creators.onGridAction('currentPage', currentPage)) },
    onPageSizeChange: (pageSize) => { dispatch(FilterLogAccessiReducer.creators.onGridAction('pageSize', pageSize)) },
    onColumnWidthsChange: (widths) => { dispatch(FilterLogAccessiReducer.creators.onGridAction('columnWidths', widths)) },
    handleRowSelection: (newSelection) => { dispatch(FilterLogAccessiReducer.creators.handleRowSelection(newSelection)) },
    setSelectedLogAccesso: (selected_log_accesso) => { dispatch(FilterLogAccessiReducer.creators.setSelectedLogAccesso(selected_log_accesso)) },
    handleExpandedRow: (newExpandedRowIds) => { dispatch(FilterLogAccessiReducer.creators.handleExpandedRow(newExpandedRowIds)) },
    resetFilters: () => { dispatch(FilterLogAccessiReducer.creators.resetFilters()) },
});

const mapStateToProps = state => ({
    log_accessi: state['log-accessi'].log_accessi,
    getLogAccessiRequestStatus: state['log-accessi'].status,

    selection: state['filtro-log-accessi'].selection,
    selectedRowIndex: state['filtro-log-accessi'].selectedRowIndex,
    selected_log_accesso: state['filtro-log-accessi'].selected_log_accesso,
    filters: state['filtro-log-accessi'].filters,
    sorting: state['filtro-log-accessi'].sorting,
    currentPage: state['filtro-log-accessi'].currentPage,
    pageSize: state['filtro-log-accessi'].pageSize,
    pageSizes: state['filtro-log-accessi'].pageSizes,
    expandedRowIds: state['filtro-log-accessi'].expandedRowIds,
    columnWidths: state['filtro-log-accessi'].columnWidths,

    codiceUtente: state['logged-user'].codiceUtente,
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(GridLogAccessi));